import EventMap from "./EventMap";

export default EventMap;
